import find from "lodash/find";
import values from "lodash/values";

export const formatPrerequisites = (orgPrerequisites) =>
  Object.values(orgPrerequisites || {}).map((pre_req) => ({
    id: pre_req?.attributes.id,
    name: pre_req?.attributes?.name,
    prerequisite_type: pre_req?.attributes?.prerequisiteType,
    description: pre_req?.attributes?.description,
    responsibility: pre_req?.attributes?.responsibility,
    default: pre_req?.attributes?.default,
    checked: pre_req?.attributes?.default,
  }));

export const mergePrerequisites = (
  jobcastPrerequisites,
  orgPrerequisites = []
) => {
  // checks if the jobcast has the Prerequisite in the organization settings (to mark as checked),
  // but includes previously added Prerequisites in the jobcast if the organizaiton removed them
  const tempPrerequisites = [];
  // Process orgPrerequisites first to preserve original order
  values(orgPrerequisites)
    .concat(jobcastPrerequisites)
    .forEach((prerequisite) => {
      if (find(tempPrerequisites, { id: prerequisite.id })) return;

      const name = prerequisite.name ?? prerequisite.attributes?.name ?? "";
      const description =
        prerequisite.description ?? prerequisite.attributes?.description ?? "";
      const prerequisite_type =
        prerequisite.prerequisite_type ??
        prerequisite.attributes?.prerequisite_type ??
        "basic";
      const isDefault =
        prerequisite.default ?? prerequisite.attributes?.default ?? false;
      const responsibility =
        prerequisite.responsibility ??
        prerequisite.attributes?.responsibility ??
        "either_party";

      tempPrerequisites.push({
        id: prerequisite.id,
        name,
        prerequisite_type,
        description,
        responsibility,
        default: isDefault,
        checked:
          isDefault ||
          Boolean(find(jobcastPrerequisites, { id: prerequisite.id })),
      });
    });
  return tempPrerequisites;
};
